import { createContext } from 'react';

export interface AuthUser {
  id: string;
  email: string | undefined;
  name: string | undefined;
  image: string | undefined;
  tokenBalance: number;
  role: 'admin' | 'user';
}

export interface AuthContextType {
  user: AuthUser | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  isAdmin: boolean;
  signIn: () => void;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | null>(null);
